"use strict";

angular.module("licensure.services").factory("EXExaminers", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/ExamModule/ExamExaminers", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });
                return d.promise;
            },

            getFilter: function (filter) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/AvailableExamExaminers", {
                        params: {
                            currentPage: filter.currentPage,
                            numPerPage: filter.numPerPage,
                            reverse: filter.reverse,
                            sortBy: filter.sortBy,
                            search: filter.search,
                            alphaFilter: filter.alphaFilter,
                            internal: (filter.filters && filter.filters.length > 0 && filter.filters[0].value != undefined && filter.filters[0].value != null) ? filter.filters[0].value : null,
                            licenseCategoryLevelId: (filter.filters && filter.filters.length > 1 && filter.filters[1].value != undefined && filter.filters[1].value != null) ? filter.filters[1].value : null,
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data.records);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });
                return d.promise;
            },

            getCount: function (filter) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ExamModule/AvailableExamExaminers/getCount', {
                        params: {
                                search: filter.search,
                                alphaFilter: filter.alphaFilter,
                                internal: (filter.filters && filter.filters.length > 0 && filter.filters[0].value != undefined && filter.filters[0].value != null) ? filter.filters[0].value : null,
                                licenseCategoryLevelId: (filter.filters && filter.filters.length > 1 && filter.filters[1].value != undefined && filter.filters[1].value != null) ? filter.filters[1].value : null,
                            }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            save: function (id) {
                var d = $q.defer();

                $http({
                    method: "POST",
                    url: apiLocation + "/api/ExamModule/ExamExaminers/",
                    data: id
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/ExamModule/ExamExaminers/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

        };
    }
]);
